/** `ids` with `moving` taken out and put where `target` is. */
export function moveStage(ids: string[], moving: string, target: string): string[] {
  const without = ids.filter((id) => id !== moving);
  const at = without.indexOf(target);
  if (at < 0 || moving === target) return ids;
  const from = ids.indexOf(moving);
  const to = ids.indexOf(target);
  without.splice(from < to ? at + 1 : at, 0, moving);
  return without;
}
